/* global mobile_menu_params */
/* eslint no-unused-vars: */
import Mmenu from 'mmenu-js'

document.addEventListener('DOMContentLoaded', () => {
	let mobileMenu = document.querySelector('nav.mobile-menu')
	mobileMenu.classList.remove(...mobileMenu.classList)
	mobileMenu.classList.add(...['mobile-menu', 'wp-navigation', 'hidden'])

	let menu_title = ''
	if (mobile_menu_params && Object.prototype.hasOwnProperty.call(mobile_menu_params, 'menu_title')) {
		menu_title = mobile_menu_params.menu_title
	}

	const menu = new Mmenu(
		document.querySelector('nav.mobile-menu'),
		{
			theme: 'light',
			navbar: {
				add: true,
				title: menu_title,
				titleLink: 'none', // WCAG "Adjacent links" issue
			},
			screenReader: {
				// WCAG "Links with different destinations" issue
				aria: true,
				text: true,
			},
			offCanvas: {
				position: 'right',
			},
			counters: {
				add: true,
			},
		},
		{
			classNames: {
				selected: 'current-menu-item',
			},
			offCanvas: {
				page: {
					noSelector: ['#wpadminbar', '#guide'],
				},
			},
		}
	)

	const api = menu.API
	window.mobileMenu = menu

	document.getElementById('main_menu_toggle_js').addEventListener('click', event => {
		event.preventDefault()

		api.open()
	})

	document.getElementById('mm-0').addEventListener('click', event => {
		event.preventDefault()

		api.close()
	})

	mobileMenu.classList.remove('hidden')
	document.querySelector('ul.mobile-menu').classList.remove('hidden')
	document.getElementsByTagName('body')[0].classList.remove('mm-wrapper--position-right')
})
